import { Image as ToolkitImage } from '@storyofams/storyblok-toolkit';
import { classNames } from '~/lib';

interface GalleryProps {
  content: any;
}

const getType = (src: string) => {
  const dimensions = src?.match(/\/(\d*)x(\d*)\//);

  const w = dimensions?.[1];
  const h = dimensions?.[2];

  return w && h && parseInt(w) / parseInt(h) > 1 ? 'portrait' : 'landscape';
};

export const Gallery = ({ content }: GalleryProps) => {
  return (
    <div className="relative overflow-x-auto xl:px-4 snap-x">
      <div className="flex xl:flex-wrap xl:justify-between xl:px-10 min-w-max xl:min-w-0">
        {content?.map((image) => {
          const orientation = getType(image?.filename);

          return (
            <div
              key={image?.id}
              className={classNames(
                'overflow-hidden rounded-3xl xl:max-h-[360px] w-full xl:mb-10 mr-6 xl:mr-0 first:ml-6 first:xl:ml-0 snap-center',
                orientation === 'portrait'
                  ? 'w-[480px] md:w-[640px]'
                  : 'w-[295px] md:w-[360px]',
              )}
            >
              <div
                className={classNames(
                  'relative w-full overflow-hidden rounded-3xl',
                )}
              >
                <ToolkitImage
                  alt={image?.alt || ''}
                  src={image?.filename}
                  fluid={image?.size ? 1600 : 1200}
                  fit="contain"
                  showPlaceholder={false}
                  className={classNames('w-full max-w-100', 'rounded-3xl')}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
